// Preserves what the user is looking at when content elsewhere on the page changes height
// (e.g. a table above the viewport gains/loses rows) and would otherwise shift the window's
// scroll position, making the visible content appear to "jump".
//
// captureScrollAnchor(el) walks up from el through its real DOM ancestors (not ids/selectors,
// so it works regardless of which page/component tree it's used in) and records each one's
// position. restoreScrollAnchor(anchor) re-measures the first ancestor still attached to the
// document (the clicked element itself may have been removed, e.g. its row disappeared) and
// scrolls by the difference, so that element ends up back where it was on screen.
export const captureScrollAnchor = (el) => {
	const chain = []
	let node = el
	while(node && node !== document.body) {
		chain.push({ el: node, top: node.getBoundingClientRect().top })
		node = node.parentElement
	}
	return chain
}

export const restoreScrollAnchor = (anchor) => {
	if(!anchor) return
	for(const { el, top } of anchor) {
		if(el.isConnected) {
			const delta = el.getBoundingClientRect().top - top
			if(delta) window.scrollBy(0, delta)
			return
		}
	}
}
